import { Form, Formik, FormikProps } from 'formik';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import templateApi, { AddTemplateDataType } from '../../../APIs/template';
import { dropDownData } from '../../../components/AdminSettings/Country/dropdownData';
import {
  BrowseFile,
  Button,
  FormContainer,
  Input,
  Typography,
} from '../../../designComponents';
import SelectDropDown from '../../../designComponents/SelectDropdown';
import { FileWithKeys, requestAPI, uploadFilesToS3 } from '../../../utils';
import { AddTemplateStyled } from './style';

const validationSchema = Yup.object().shape({
  templateTitle: Yup.string().required('Template title is required'),
  country: Yup.string().required('Country is required'),
});

const AddTemplate = () => {
  const formikRef = useRef<FormikProps<AddTemplateDataType>>(null);
  const [files, setFiles] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [initialValues, _setInitialValues] = useState<AddTemplateDataType>({
    templateTitle: '',
    country: '',
    uploadTemplate: [],
  });

  const handleAddTemplate = async (values: typeof initialValues) => {
    try {
      if (files.length === 0) return;

      setLoading(true);
      let fileWithKeys: FileWithKeys[] = [];
      if (files && files.length > 0) {
        fileWithKeys = (await uploadFilesToS3(files)) as FileWithKeys[];
      }

      if (fileWithKeys && fileWithKeys.length === files.length) {
        const keys = fileWithKeys.map((fwk) => fwk.key);

        await requestAPI(
          templateApi.addTemplate({
            templateTitle: values.templateTitle,
            country: values.country,
            uploadTemplate: keys,
          })
        );
      }
      setLoading(false);
      toast.success('template added successfully');
      navigate(-1);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <AddTemplateStyled>
      <Typography variant="title" className="heading">
        Add Template
      </Typography>
      <Formik
        innerRef={formikRef}
        onSubmit={handleAddTemplate}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({ values, setFieldValue, touched, errors, handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <FormContainer
                label="Template Name"
                error={touched.templateTitle ? errors.templateTitle : ''}
              >
                <Input
                  placeholder="Template Name"
                  name="templateTitle"
                  value={values.templateTitle}
                  onChange={(e) =>
                    setFieldValue('templateTitle', e.target.value)
                  }
                />
              </FormContainer>
              <FormContainer
                label="Country"
                error={touched.country ? errors.country : ''}
              >
                <SelectDropDown
                  options={dropDownData}
                  placeholder="Select a country"
                  selected={values.country || ''}
                  onSelect={(selectedCountry: string) => {
                    setFieldValue('country', selectedCountry);
                  }}
                />
              </FormContainer>
              <FormContainer
                label="Upload Template"
                error={
                  touched.uploadTemplate &&
                  typeof errors.uploadTemplate === 'string'
                    ? errors.uploadTemplate
                    : ''
                }
              >
                <div className="browse-files">
                  <BrowseFile
                    setFiles={(selectedfiles: File[]) => {
                      setFiles(selectedfiles);
                      const newTemplate = [...(values.uploadTemplate || [])];

                      setFieldValue('templateFiles', newTemplate);
                    }}
                    files={files}
                    accepts=".jpg, .png, .jpeg, .svg"
                    multiple
                  />
                </div>
              </FormContainer>
              <Button
                variant="secondary"
                type="submit"
                isLoading={loading}
                size="lg"
                style={{
                  padding: '7px 30px',
                }}
              >
                Continue
              </Button>
            </Form>
          );
        }}
      </Formik>
    </AddTemplateStyled>
  );
};

export default AddTemplate;
